export enum FeedbackSource {
    FRONTEND = 1,
    DASHBOARD = 2
}
